import * as lib from '~/dependencies';
import { colors, fonts, paddings } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-left: ${paddings.alternative}px;
  padding-right: ${paddings.alternative}px;

  .title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    div {
      display: flex;
      flex: 1;
      max-height: 1px;
      min-height: 1px;
      background-color: ${colors.lightGray06};
      opacity: 0.5;
    }
    span {
      font-size: 12px;
      color: ${colors.black};
      opacity: 0.5;
      margin-left: 5px;
      margin-right: 5px;
      font-weight: 600;
    }
  }
`;

export const BoxSelect = lib.styled.div`
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  flex-direction: column;
  background-color: ${colors.white02};
  border: 1px solid ${colors.lightGray06};
  border-radius: 10px;

  .inputSelect {
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    font-size: ${fonts.default}px;

    &::before {
      border-bottom: 0!important;
    }

    &::after {
      border-bottom: 0!important;
    }

    div {
      width: 290px;
      padding: 5px;
    }
  }
`;

export const Row = lib.styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 25px;
`;

export const Column = lib.styled.div`
  display: flex;
  flex-direction: column;

  .text-description {
    font-size: 12px;
    color: #000;
    opacity: 0.5;
    margin-right: 5px;
    font-weight: 600;
  }
`;
